export const HOME_APPS_PATH = '/home/apps';
export const HOME_DASHBOARD_PATH = '/home/dashboard';
